import useFormatCurrency from '../../hooks/useFormatCurrency';
import useMoneyClass from '../../hooks/useMoneyClass';

/** Formatted currency with correct Arabic RTL alignment (number → currency name). */
export function MoneyAmount({ amount, className = '', as: Tag = 'span' }) {
  const format = useFormatCurrency();
  const moneyClass = useMoneyClass(className);
  return <Tag className={moneyClass || undefined}>{format(amount ?? 0)}</Tag>;
}

/** Wrap pre-formatted currency text; applies `.ads-money` (+ RTL when Arabic). */
export function MoneyText({ children, className = '' }) {
  const moneyClass = useMoneyClass(className);
  return <span className={moneyClass || undefined}>{children}</span>;
}

export default MoneyAmount;
